'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';


import Image from '@eliadmin/core/src/components/image/image-wrapped';
import Link from '@eliadmin/core/src/components/link';

import type { TDynamicData } from '../../types/dynamic-data';

import { cn } from '@eliadmin/core/src/utils/style-utils';

import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/pagination';

import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import { Button } from '@eliadmin/core/src/components/ui/button';

export function Events({ events }: { events: TDynamicData[] }) {
  return (
    <section className={cn('custom-section', 'mt-40 pr-0 sm:mt-32 md:mt-24 lg:mt-16')}>
      <div className={cn('custom-container')}>
        <h2
          className={cn(
            'font-heading uppercase',
            'pr-6 text-3xl font-light text-foreground sm:text-4xl lg:text-5xl',
          )}
        >
          NENECHAJ SI UJSŤ A <strong className="font-semibold">ZAŽITE TO S NAMI!</strong>
        </h2>
        <Swiper
          pagination={true}
          navigation={true}
          autoplay={{ delay: 3000 }}
          modules={[Pagination, Navigation, Autoplay]}
          loop={true}
          className={cn('mySwiper', 'ea-custom-swiper', 'ea-categories-slider__swiper', 'w-full')}
          spaceBetween={16}
          slidesPerView={1.2}
          breakpoints={{
            1280: {
              slidesPerView: 1.5,
              spaceBetween: 32,
            },
            1024: {
              slidesPerView: 1.3,
              spaceBetween: 24,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            480: {
              slidesPerView: 1.15,
            },
          }}
        >
          {events.map(event => (
            <SwiperSlide key={event.name} className="!h-auto lg:!h-[550px] xl:!h-[600px]">
              <div className="relative hidden h-full w-full lg:block">
                <div className="absolute right-0 top-0 z-[4] flex h-full flex-col items-center justify-center gap-8 bg-primary/85 px-8 lg:w-[50%] xl:w-[45%] xl:px-10 2xl:w-[40%]">
                  <h3 data-ea-visual-tag="h4"
                    className={cn(
                      'font-heading uppercase',
                      'w-full text-center text-3xl font-medium text-white',
                    )}
                  >
                    {event.name}
                  </h3>
                  <Button asChild variant={'secondary'}>
                    <Link prefetch={false} href={`/udalost/${event.slug}`} aria-label={`Čítať viac: ${event.name}`}>
                      ČÍTAJ VIAC
                    </Link>
                  </Button>
                </div>
                <Image
                  src={event?.image?.url ?? '/images/placeholder.png'}
                  alt={resolveImageAlt(event?.image, event?.name)}
                  fill
                  sizes="auto, 100vw"
                  style={{ objectFit: 'cover', objectPosition: 'center' }}
                  className="absolute inset-0 z-0 h-full w-full"
                />
              </div>
              <div className="flex h-full w-full flex-col items-start justify-start lg:hidden">
                <div className="relative aspect-video w-full">
                  <Image
                    src={event?.image?.url ?? '/images/placeholder.png'}
                    alt={resolveImageAlt(event?.image, event?.name)}
                    fill
                    sizes="auto, 100vw"
                    style={{ objectFit: 'cover', objectPosition: 'center' }}
                  />
                </div>
                <div className="flex w-full flex-col items-start justify-start gap-6 bg-primary p-4 sm:p-6 md:p-8">
                  <h3 data-ea-visual-tag="h4"
                    className={cn(
                      'font-heading uppercase',
                      'line-clamp-1 w-full text-lg font-medium text-white sm:text-lg md:text-xl',
                    )}
                  >
                    {event.name}
                  </h3>
                  <Button asChild variant={'secondary'}>
                    <Link prefetch={false} href={`/udalost/${event.slug}`} aria-label={`Čítať viac: ${event.name}`}>
                      ČÍTAJ VIAC
                    </Link>
                  </Button>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}
